import React, { useRef } from 'react';
import { UseDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { useScrollLock } from 'src/shared/hooks/useScrollLock';
import {
  BottomButton,
  BottomContainer,
  BottomWrapper,
  ClearButton,
  CloseButton,
  CloseButtonContainer,
  Header,
  SectionContainer,
} from '../../../../components/DishFirstHeader/styles/modal';
import { getAllFiltersCount } from '../../utils';

interface BaseFilterModalProps {
  filters: UseDishFirstExploreUrl;
  header?: React.ReactNode;
  isShowing?: boolean;
  largeHeader?: boolean;
  showCTA?: boolean;
  showHeader?: boolean;
  onHide: () => void;
}

export const BaseFilterModal: React.FC<React.PropsWithChildren<BaseFilterModalProps>> = ({
  children,
  filters,
  header,
  isShowing,
  largeHeader = false,
  showCTA = true,
  showHeader = true,
  onHide,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useScrollLock({
    enabled: isShowing,
    scrollableTargetRef: ref,
  });

  const filterCount = getAllFiltersCount(filters);

  return (
    <SectionContainer show={isShowing} ref={ref} largeHeader={largeHeader}>
      {showHeader && (
        <Header largeHeader={largeHeader}>
          <CloseButtonContainer onClick={onHide}>
            <CloseButton />
          </CloseButtonContainer>
          {header}
        </Header>
      )}
      {children}
      {showCTA && (
        <BottomContainer>
          <BottomWrapper>
            {Boolean(filterCount) && <ClearButton onClick={filters.clearQueryParams}>Clear all</ClearButton>}
          </BottomWrapper>
          <BottomWrapper>
            <BottomButton onClick={onHide}>View Dishes</BottomButton>
          </BottomWrapper>
        </BottomContainer>
      )}
    </SectionContainer>
  );
};
